import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import LeasingNavigationIcon from 'Icons/NavigationItem/Leasing';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyLeasingSettingsPage = React.lazy(() => import('./Pages'));

const leasingSettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.leasing.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.leasing.title',
            url: '/leasing-settings',
            Icon: LeasingNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyLeasingSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default leasingSettingsConfiguration;
